"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function timeoutPromise(ms, promise, friendlyName) {
    // Create a promise that rejects in <ms> milliseconds
    var timeout = new Promise(function (resolve, reject) {
        var id = setTimeout(function () {
            clearTimeout(id);
            reject((friendlyName ? friendlyName + " p" : "P") + 'romise timed out in ' + ms + 'ms.');
        }, ms);
    });
    // Returns a race between our timeout and the passed in promise
    return Promise.race([
        promise,
        timeout
    ]);
}
exports.timeoutPromise = timeoutPromise;
//# sourceMappingURL=timeoutPromise.js.map